import React from 'react';

import TableRow from './TableRow.jsx';

const TableBody = (props) => {
    let userListRowTableNodes;
    if (props.usuariosFiltrados != undefined && props.usuariosFiltrados != "") {

        userListRowTableNodes = props.usuariosFiltrados.map(row => {
            
            if (props.tipoOperacion == 1) {
                if (row.Activo) {
                    let estado;
                    let bloqueadoPorInactividad = false;
                    let isCurrentUser = false;

                    if (row.Activo == true && row.Bloqueado == false) {
                        estado = 0;
                    }
                    if (row.Activo == false && row.Bloqueado == true) {
                        estado = 1
                    }
                    if (row.Activo == false && row.Bloqueado == false) {
                        estado = 2
                    }
                    if ((row.Activo == false && row.Bloqueado == true)) {
                        estado = 1
                    }
                    if (row.Bloqueado_Inactividad == true) {
                        estado = 3
                    }

                    if (row.Id == props.currentUser)
                        isCurrentUser = true;



                    return (
                        <TableRow ID={row.Id} nombre={row.Nombre} login={row.Login}
                            sucursal={row.SUCURSAL} sector={row.SECTOR}
                            estado={estado} isChecked={row.Seleccionado == true ? true : false} motivo={row.MotivoBloqueo}
                            bloqueadoPor={row.BloqueadoPor} fechaBloqueado={row.FechaBloqueo}
                            horaBloqueado={row.HoraBloqueo} eliminadoPor={row.EliminadoPor}
                            fechaEliminado={row.FechaEliminado} horaEliminado={row.HoraEliminado}
                            functions={props.functions} isCurrentUser={isCurrentUser}
                            setCheckbox={props.setCheckbox}
                            setUserState={props.setUserState}
                            saveSessionStorage={props.saveSessionStorage}
                            idPerfil={props.idPerfil}
                        />
                    );
                }
            } else {

                let estado;
                let isCurrentUser = false;

                if (row.Activo == true && row.Bloqueado == false) {
                    estado = 0;
                }
                if (row.Activo == false && row.Bloqueado == true) {
                    estado = 1
                }
                if (row.Activo == false && row.Bloqueado == false) {
                    estado = 2
                }
                if ((row.Activo == false && row.Bloqueado == true)) {
                    estado = 1
                }
                if (row.Bloqueado_Inactividad == true) {
                    estado = 3
                }

                if (row.Id == props.currentUser)
                    isCurrentUser = true;

                return (
                    <TableRow ID={row.Id} nombre={row.Nombre} login={row.Login}
                        sucursal={row.SUCURSAL} sector={row.SECTOR}
                        estado={estado} isChecked={row.Seleccionado == true ? true : false} motivo={row.MotivoBloqueo}
                        bloqueadoPor={row.BloqueadoPor} fechaBloqueado={row.FechaBloqueo}
                        horaBloqueado={row.HoraBloqueo} eliminadoPor={row.EliminadoPor}
                        fechaEliminado={row.FechaEliminado} horaEliminado={row.HoraEliminado}
                        functions={props.functions} isCurrentUser={isCurrentUser}
                        setCheckbox={props.setCheckbox}
                        saveSessionStorage={props.saveSessionStorage}
                        setUserState={props.setUserState}
                    />
                );
            }

        });
    }

    return (
        <tbody>
            {userListRowTableNodes}
        </tbody>
    );
}

export default TableBody;